import { useNotificationsStore } from "../stores/notificationsStore";
import type { ConnectionStatus } from "../types";
import { cn } from "@/lib/utils/cn";

const tone: Record<ConnectionStatus, string> = {
  connected: "bg-success",
  reconnecting: "bg-warning animate-pulse",
  disconnected: "bg-danger",
};

const title: Record<ConnectionStatus, string> = {
  connected: "Notificações em tempo real conectadas",
  reconnecting: "Reconectando notificações…",
  disconnected: "Notificações em tempo real desconectadas",
};

export function ConnectionStatusDot({ className }: { className?: string }) {
  const status = useNotificationsStore((s) => s.connectionStatus);
  return (
    <span
      role="status"
      title={title[status]}
      aria-label={title[status]}
      className={cn(
        "inline-block h-1.5 w-1.5 shrink-0 rounded-full",
        tone[status],
        className,
      )}
    />
  );
}
